<template>
  <div class="vehicle-list-container">
    <!-- 车辆绑定信息展示区域 -->
    <div v-show="chetouhao && cheguahao" class="bind-info-section">
      <vehicle-bind-info
        :chetouhao="chetouhao"
        :cheguahao="cheguahao"
        @cancelBind="cancelBind"
      ></vehicle-bind-info>
    </div>

    <!-- 如果无绑定车辆则会自动跳转到添加页面 -->
    <div v-show="!chetouhao && !cheguahao" class="empty-state">
      <van-empty description="暂无绑定车辆信息" />
    </div>

    <!--
    <div class="bind-detail-info">
      <van-tabs v-model="active" animated>
        <van-tab  v-for="(title, index) in tabTitles"  :key="index"  :title="title">

        </van-tab>
      </van-tabs>
      <component :is="activeComponent" ></component>
    </div>
    -->

    <Tabbar></Tabbar>
  </div>
</template>
<script>
import Tabbar from '@/views/Public/tabbarTpl.vue';
import VehicleBindInfo from '@/pages/SteamVehicle/vehicleBindInfo.vue';
import api from '@/fetch/api';
import { Toast } from 'vant';
import store from '@/store';
export default {
  inject: ['reload'],
  components: {
    Tabbar,
    VehicleBindInfo,
  },
  data() {
    return {
      chetouhao: '',
      cheguahao: '',
      active: 0,
      vehicleState: '02',
      tabTitles: ['车头', '车挂'],
      componentsMap: ['ChetouList', 'CheguaList'],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.active = to.query.savedTab;
      if (vm.active == null) vm.active = 0;
    });
  },
  created() {
    document.title = '车辆管理';
    //this.getBindVehicleState();
    this.getBindVehicleInfo();
  },
  mounted() {
    if (this.$store.state.isFirstTime && this.$route.query.bootFlag === 'finish') {
      var openid = this.$store.state.wx_info.openid;
      api.getChetouBeianDetail(openid).then((res) => {
        console.log(JSON.parse(res).data);
        if (JSON.parse(res).data.bpmstatus == 1) {
          this.$router.push({
            name: 'steamxy',
          });
        } else {
          this.$router.push({
            name: 'index',
            query: {
              bootFlag: 'final',
            },
          });
        }
      });
    }
  },
  computed: {
    //获取当前绑定的车辆信息
    activeComponent() {
      // 返回当前活动的组件
      return this.componentsMap[this.active];
    },
  },
  methods: {
    //获取绑定车辆信息
    getBindVehicleInfo() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;

      api
        .getVehicleInfo(openid)
        .then(function (resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.chetouhao = res.data.chetouhao;
            that.cheguahao = res.data.cheguahao;
            // 如果没有绑定, 则跳转到addAllCar
            if (!that.chetouhao && !that.cheguahao) {
              that.$router.push({
                name: 'addAllCar',
              });
            } else {
              if (that.$store.state.isFirstTime) {
                api.getChetouBeianDetail(openid).then((res) => {
                  console.log(JSON.parse(res).data);
                  if (JSON.parse(res).data.bpmstatus == 1) {
                    that.$router.push({
                      name: 'steamxy',
                    });
                  } else {
                    that.$router.push({
                      name: 'index',
                      query: {
                        bootFlag: 'final',
                      },
                    });
                  }
                });
              }
            }
          }
        })
        .catch(function () {
          Toast.fail('连接失败，请刷新页面');
        });
    },
    //取消绑定
    cancelBind() {
      this.reload();
    },
    getBindVehicleState() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api
        .getBindVehicleState(openid)
        .then(function (resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.vehicleState = res.data.yhzt;
          }
        })
        .catch(function () {
          Toast.fail('连接失败，请刷新页面');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.vehicle-list-container {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 60px;
}

.bind-info-section {
  padding-top: 12px;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  background-color: #fff;
  margin: 12px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>
